export const RAPID_API_KEY: string =
    'eda21b8c50msh51cd2e356cca3e3p1519f1jsne2fe77c66905'
export const INSTAGRAM_HOST: string = 'instagram47.p.rapidapi.com'
export const TWITTER_HOST: string = 'twitter-search2.p.rapidapi.com'